/**
 * Firestore historically stored onboarding as 5 phases (0 workspace … 4 complete).
 * Workspace language/currency are now collected at workspace creation, so we use
 * 4 phases (0 blocks … 3 complete). This maps legacy values to the canonical index.
 */
export function normalizeOnboardingStep(
  raw: number | undefined | null
): number {
  if (raw == null || raw < 0) return 0;
  if (raw <= 1) return 0;
  return Math.min(raw - 1, 3);
}

/** After login / workspace selection: wizard until onboarding is complete, then dashboard. */
export function postAuthWorkspacePath(
  workspace?: { onboardingStep?: number } | null
): '/onboarding' | '/dashboard' {
  return normalizeOnboardingStep(workspace?.onboardingStep) >= 3 ?
    '/dashboard' :
    '/onboarding';
}
